import React, { useEffect, useState } from 'react';
import { getCurrentUser, fetchAuthSession } from 'aws-amplify/auth';
import Logo from './Logo';

function AuthCallback({ onAuthSuccess }) {
  const [status, setStatus] = useState('processing');

  useEffect(() => {
    handleAuthCallback();
  }, []);

  const handleAuthCallback = async () => {
    try {
      // Esperar un poco para que Amplify procese el callback
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      //console.log('🔄 Procesando callback de autenticación...');
      
      // Intentar obtener el usuario actual
      const user = await getCurrentUser();
      const session = await fetchAuthSession();
      
      //console.log('✅ Usuario autenticado exitosamente:', user);
      //console.log('🎫 Sesión obtenida:', session);
      
      if (user && session) {
        setStatus('success');
        onAuthSuccess(user, session);
      } else {
        setStatus('error');
      }
    } catch (error) {
      console.error('❌ Error procesando callback:', error);
      setStatus('error');
      
      // Intentar de nuevo después de un delay
      setTimeout(() => {
        handleAuthCallback();
      }, 2000);
    }
  };

  return (
    <div className="login-container animate-fade-in">
      <div className="login-card card">
        <div className="login-header">
          <Logo variant="full" size="large" />
          {status === 'processing' && (
            <>
              <h2 className="card-title">Procesando autenticación...</h2>
              <div className="loading-spinner"></div>
              <p>Completando el proceso de inicio de sesión...</p>
            </>
          )}
          {status === 'success' && (
            <>
              <h2 className="card-title">¡Autenticación exitosa!</h2>
              <p>Redirigiendo al dashboard...</p>
            </>
          )}
          {status === 'error' && (
            <>
              <h2 className="card-title">Error de autenticación</h2>
              <p>Hubo un problema con el inicio de sesión. Reintentando...</p>
              <div className="loading-spinner"></div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default AuthCallback; 